import { Sparkles } from 'lucide-react';

type BetaBannerProps = {
  className?: string;
};

export const BetaBanner = ({ className = '' }: BetaBannerProps) => (
  <div
    className={`flex items-start gap-2.5 px-4 py-2.5 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200/50 rounded-full shadow-sm ${className}`}
    role="note"
    aria-label="Beta feature notice"
  >
    <Sparkles className="h-4 w-4 text-amber-600 flex-shrink-0 mt-0.5" aria-hidden="true" />
    <p className="text-sm text-gray-700 leading-relaxed">
      This feature is currently in beta. We're actively testing and improving it. You may notice changes or occasional issues as we continue to refine the experience.
    </p>
  </div>
);
